module.exports = __webpack_public_path__ + "static/media/lloyds-bank.2bb2d0e5.svg";